<template>
  <div :class="classes" @click="$emit('click', tabBarItem)">
    <div class="tab-bar-item__icon">
      <component :is="iconComponent" />
    </div>
    <div class="tab-bar-item__label">
      {{ tabBarItem.label }}
    </div>
  </div>
</template>

<script>
// @flow

import { ChatIcon, WizardIcon } from './Icons'

export default {
  components: {
    ChatIcon,
    WizardIcon
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    tabBarItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    classes (): Object {
      return {
        'tab-bar-item': true,
        'tab-bar-item--is-active': this.isActive
      }
    },
    iconComponent (): any {
      const components = {
        chat: 'ChatIcon',
        wizard: 'WizardIcon'
      }

      return components[this.tabBarItem.icon] ?? null
    }
  }
}
</script>

<style src="./tab-bar-item.scss" />
